window.theme = window.theme || {};
function updateCartAttributes(attrs) {
  fetch(`${window.Theme.routes.cart_update_url}.js`, {
    body: JSON.stringify({
      attributes: attrs,
    }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => response.json())
    .then((response) => {
      //cart.renderContents(response);
    });
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.querySelectorAll('[id^="ModalClose-"]').forEach((btn) => {
      btn.addEventListener('click', this.hide.bind(this, false));
    });
    this.addEventListener('keyup', (event) => {
      if (!event.code) return;
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button') || this.querySelector('input');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalDatePicker extends ModalDialog {
  constructor() {
    super();

    this.datePicker = new HPDatePicker();
    this.placeHolderDateInput = document.querySelector('#date-picker-tigger-js');
    this.submitButton = this.querySelector('#confirm-delivery-date');
    this.submitButton.addEventListener('click', () => {
      this.closest('modal-date-picker').hide();
    });
    this.cart = JSON.parse(document.querySelector('#cart-json').innerHTML);
    this.productSpecificDisabledDates = new Set();
  }

  connectedCallback() {
    window.addEventListener('cart:update', (event) => (this.cart = event.detail.cart));
    // check if location search has a query 'redirect-reason=not-valid-deliverydate'
    // if yes, close the cart-drawer and alert the user to select a valid delivery date.
    const urlParams = new URLSearchParams(window.location.search);
    const redirectReason = urlParams.get('redirect-reason');
    if (redirectReason === 'not-valid-deliverydate') {
      setTimeout(() => {
        document.querySelector('cart-drawer').close();
        this.selectDateAlert();
      }, 100);
    }

    // if (
    //   defaultDeliveryDate &&
    //   defaultDeliveryDate != '' &&
    //   this.dataset.postalCode != '' &&
    //   window.theme.isValidDate(defaultDeliveryDate)
    // ) {
    //   this.querySelector('#postcode').value = this.dataset.postalCode;
    //   console.log('defaultDeliveryDate', defaultDeliveryDate);
    //   this.querySelector('#confirm-code').removeAttribute('disabled');
    //   this.initailizeDatePicker();
    //   setTimeout(() => {
    //     try {
    //       window.deliveryDatePicker.setDate(new Date(defaultDeliveryDate));
    //       ModalDatePicker.onSelect(new Date(defaultDeliveryDate));
    //       setTimeout(() => {
    //         ModalDatePicker.onFormat(new Date(defaultDeliveryDate));
    //       }, 10);
    //     } catch (error) {
    //       // it through error if the selectd date is disabled
    //       console.log(error);
    //     }
    //   }, 10);
    //   document.querySelector('form[action="/cart"]').classList.remove('cart-form--disabled');
    // } else {
    document.querySelector('form[action="/cart"]').classList.add('cart-form--disabled');
    // }
  }

  selectDateAlert() {
    this.placeHolderDateInput.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    this.placeHolderDateInput.style.boxShadow = '0 0 0 2px #ff0000';
    document.querySelector('.delivery_modal').setAttribute('open', true);
  }

  hide() {
    super.hide();
  }

  show(opener) {
    super.show(opener);
    this.classList.remove('select-delivery-date');
  }

  showDatePicker() {
    const postalCode = document.querySelector('#postcode').value;
    const isValid = this.isValidPostcode(postalCode);

    if (!isValid && Shopify.country == 'GB') {
      return this.showErrorMessage(`Please enter a valid postcode.`);
    }

    const isPostalCodeAllowed = this.isPostalCodeAllowed(postalCode);

    if (!isPostalCodeAllowed) {
      return this.showErrorMessage(`Sorry! Unfortunately we're unable to deliver to this postcode at this time.`);
    }

    this.classList.add('select-delivery-date');
    this.handleProductRestrictions();
    this.initailizeDatePicker();
  }

  isPostalCodeAllowed(postcode) {
    const postcodeRule = window.getPostcodeRule(postcode);
    if (!postcodeRule) {
      return true;
    }

    return postcodeRule.disabledDays.length < 7;
  }

  initailizeDatePicker() {
    const postalCode = document.querySelector('#postcode').value;
    if (postalCode == '') return;
    this.datePicker.init(postalCode);
  }

  validateCode(input) {
    // console.log('validateCode', input);
    const disabled = input.value.length < 2;
    if (this.errorMessageWrapper) this.errorMessageWrapper.setAttribute('hidden', '');
    // console.log('input.value.length', input.value.length);
    // console.log('disabled', disabled);
    document.querySelector('#confirm-code').disabled = disabled;
  }

  showErrorMessage(errorMessage) {
    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.modal-date-picker__error-message-wrapper');
    this.errorMessage =
      this.errorMessage || this.errorMessageWrapper.querySelector('.modal-date-picker__error-message');
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    this.errorMessage.innerHTML = errorMessage;
  }

  /* tests to see if string is in correct UK style postcode: AL1 1AB, BM1 5YZ etc. */
  isValidPostcode(p) {
    // var postcodeRegEx = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/i;
    // var postcodeRegEx = /^[A-Z]{1,2}[0-9RCHNQ][0-9A-Z]?\s?[0-9][ABD-HJLNP-UW-Z]{2}$|^[A-Z]{2}-?[0-9]{4}$/;
    var postcodeRegEx =
      /^([Gg][Ii][Rr]0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[0-9][A-Za-z]{2})$/;
    return postcodeRegEx.test(p.replace(' ', ''));
  }

  static onSelect(date) {
    document.querySelector('#date-picker-tigger-js').value = formateDateforUI(date);
    document.querySelector('#confirm-delivery-date').disabled = false;
  }

  static onFormat(date) {
    document.querySelector('#date-picker-placeholder-js').value = date.toLocaleDateString('en-GB'); // for form submission

    var deliveryDate = new Date(date);
    var dispatchDate = new Date(date);
    if (!DeliveryDayMargin) return;
    dispatchDate.setDate(dispatchDate.getDate() - DeliveryDayMargin);

    const delieryDateISO = fixDateTimeZone(deliveryDate).toISOString();
    const dispatchDateISO = fixDateTimeZone(dispatchDate).toISOString();
    const redDateIso = fixDateTimeZone(window.refDate).toISOString();
    document.querySelector('[name="delivery-date"]').setAttribute('data-iso-date', dispatchDateISO); // for form submission
    const dateInput = document.querySelector('[name="delivery-date"]');
    const postalCode = document.querySelector('#postcode').value;
    const awin = (function (k) {
      const a = localStorage.getItem(k);
      if (!a) return '';
      const o = JSON.parse(a);
      if (o.e && Date.now() > o.e) {
        localStorage.removeItem(k);
      } else {
        return o.v;
      }
    })('awc');
    try {
      updateCartAttributes({
        delivery_date: dateInput.value,
        delivery_date_iso: delieryDateISO.split('T')[0],
        'Ship Date': dispatchDateISO, // ship date for fullfillment service
        postal_code: postalCode,
        delivery_day_margin: DeliveryDayMargin + 1, // margin between delivery date and and order placement date
        ship_day_margin: DeliveryDayMargin, // margin between dispatch date and and order placement date
        ref_date: window.refDate.toLocaleDateString('en-GB'),
        ref_date_iso: redDateIso.split('T')[0],
        awin: awin,
      });
    } catch (error) {
      console.log(error);
    } finally {
      document.querySelector('#date-cart-attribute').innerHTML = `
        <input type="hidden" name="attributes[delivery_date]" value="${dateInput.value}" />
        <input type="hidden" name="attributes[delivery_date_iso]" value="${delieryDateISO.split('T')[0]}" />
        <input type="hidden" name="attributes[Ship Date]" value="${dispatchDateISO}" />
        <input type="hidden" name="attributes[postal_code]" value="${postalCode}" />
        <input type="hidden" name="attributes[delivery_day_margin]" value="${DeliveryDayMargin + 1}" />
        <input type="hidden" name="attributes[ship_day_margin]" value="${DeliveryDayMargin}" />
        <input type="hidden" name="attributes[ref_date]" value="${window.refDate.toLocaleDateString('en-GB')}" />
        <input type="hidden" name="attributes[ref_date_iso]" value="${redDateIso.split('T')[0]}" />
        <input type="hidden" name="attributes[awin]" value="${awin}" />
      `;
      document.querySelector('form[action="/cart"]').classList.remove('cart-form--disabled');
    }
  }

  handleProductRestrictions() {
    for (const productSpecificDeliveryRestriction of window.productSpecificDeliveryRestrictions) {
      try {
        if (this.hasRestrictedProductInCart(productSpecificDeliveryRestriction)) {
          productSpecificDeliveryRestriction.inCart = true;
          //sort by date in ascending order
          productSpecificDeliveryRestriction.dates.sort((a, b) => a - b);

          if (
            productSpecificDeliveryRestriction.is_blocklist === undefined
              ? true
              : Boolean(productSpecificDeliveryRestriction.is_blocklist)
          ) {
            const originalDisabledDates = new Set(window.hp_disabledDates);
            productSpecificDeliveryRestriction.disabledDates = new Set(
              productSpecificDeliveryRestriction.dates
                .filter((date) => !originalDisabledDates.has(date))
                .map((dateString) => new Date(dateString)),
            );

            window.hp_disabledDates = Array.from(
              new Set([...window.hp_disabledDates, ...Array.from(productSpecificDeliveryRestriction.disabledDates)]),
            );
          } else {
            this.productSpecificDisabledDates = this.getDisabledDates(productSpecificDeliveryRestriction.dates, 365);
            window.deliveryDateWhitelistApplied = true;
            window.hp_disabledDates = Array.from(
              new Set([...window.hp_disabledDates, ...this.productSpecificDisabledDates]),
            );
          }

          if (productSpecificDeliveryRestriction.blocked_days.length > 0) {
            if (!this.postCodesExcludedWeekDaysOriginal) {
              this.postCodesExcludedWeekDaysOriginal = [...window.postCodesExcludedWeekDays];
            }

            const mappedDays = productSpecificDeliveryRestriction.blocked_days.map((day) =>
              window.theme.weekDays.indexOf(day),
            );
            window.postCodesExcludedWeekDays.push(...mappedDays);
          }
        } else {
          //product used to be in cart but not anymore
          if (productSpecificDeliveryRestriction.inCart) {
            //remove dates disabled by this product and were not disabled in general
            window.hp_disabledDates = window.hp_disabledDates.filter(
              (date) => !productSpecificDeliveryRestriction.disabledDates.has(date),
            );

            if (productSpecificDeliveryRestriction.blocked_days.length > 0) {
              if (this.postCodesExcludedWeekDaysOriginal) {
                window.postCodesExcludedWeekDays = this.postCodesExcludedWeekDaysOriginal;
              }
            }
          }
          productSpecificDeliveryRestriction.inCart = false;
        }
      } catch (error) {
        console.error(`Error handling delivery restrictions for ${productSpecificDeliveryRestriction.title}`, error);
      }
    }
  }

  hasRestrictedProductInCart(restriction) {
    return this.cart.items.some(
      (item) => restriction.skus.includes(item.sku) || restriction.variant_ids.includes(item.variant_id),
    );
  }

  getDisabledDates(dates, daysAhead) {
    const currentDate = new Date();
    const lastDate = new Date(dates[dates.length - 1]);
    const endDatePlusAdditional = new Date(lastDate);
    endDatePlusAdditional.setDate(endDatePlusAdditional.getDate() + daysAhead);
    const disabledDates = new Set();

    while (currentDate <= endDatePlusAdditional) {
      if (!dates.includes(currentDate.toISOString().split('T')[0])) {
        disabledDates.add(new Date(currentDate));
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return disabledDates;
  }
}
customElements.define('modal-date-picker', ModalDatePicker);
